import { useEffect, useState } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import AppRouter from './routing/app-router'
import { Watchdog } from '@Techedge/smart-shared'
import { locale as initialLocale } from '@/root.component'
import {
    ability,
    AbilityContext,
    permissionsActions,
    apm
} from '@Techedge/digitalportal-shared'
import {
    importMessages,
    LocaleMessages,
    SmartlyIntlProvider,
} from './../app/utils/localization/intlHelper'
import './App.scss'
// import apm from '@Techedge/smart-root'

export const App = (props: any) => {
    const [locale, setLocale] = useState<string>(initialLocale)
    const [messages, setMessages] = useState<LocaleMessages | null>(null)
    let transaction = apm.getCurrentTransaction()

    const onPageLoaded = () => {
        if (transaction) {
            transaction.name = "HomePageLoad"
            const span = transaction.startSpan("HomePageLoad", "app-load", {blocking: true})
            span.end(span._start + 1)
            transaction.end() 
        }
    }

    useEffect(() => {
        onPageLoaded()
        setLocale(initialLocale)
        moment.locale(initialLocale)
        setTimeout(() => {
            let fullLoader = document.getElementsByClassName(
                'smart-overlay-app-loader'
            )[0] as HTMLElement
            if (fullLoader) {
                fullLoader.style.display = 'none'
            }
        }, 1000)
        return () => {
            let fullLoader = document.getElementsByClassName(
                'smart-overlay-app-loader'
            )[0] as HTMLElement
            if (fullLoader) {
                fullLoader.style.display = 'flex'
            }
        }
    }, [])

    useEffect(() => {
        if (props?.language && props?.dictionary) {
            setLocale(props.language)
            moment.locale(props.language)
            importMessages(props.language).then(() => {
                setMessages(props.dictionary)
            })
        }
    }, [props.language, props.dictionary])

    return (
        <SmartlyIntlProvider locale={locale} messages={messages}>
            <AbilityContext.Provider value={ability}>
                {!!messages && (
                    <Watchdog providerName="HOME" userProfile={props.userProfiles[0]?.profile}>
                        <div id="smart-home">
                            <AppRouter {...props} />
                        </div>
                    </Watchdog>
                )}
            </AbilityContext.Provider>
        </SmartlyIntlProvider>
    )
}

const mapStateToProps = (state: any) => ({
    token: state.userReducer.accessToken,
    language: state.userReducer.user.language,
    dictionary: state.userReducer.user.dictionary,
    userProfiles: state.userReducer.user.application_profiles || []
})

const mapDispatchToProps = (dispatch: any) => ({
    getActions: () => dispatch(permissionsActions.getActions()),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
